import React from 'react';
import clsx from 'clsx';

import CommonTooltipEllipses from '../../../common-tooltip-ellipses/CommonTooltipEllipses';

import scss from './StackedHorizontalBars.module.scss';

function StackedHorizontalBarsLabels({ labels }) {
  return (
    <div className={scss.scalesWrapper}>
      {labels.map((label, index) => (
        <div className={scss.scaleItem} key={`${label}-${index}`}>
          <CommonTooltipEllipses toolTipText={label} label={label} className={clsx(scss.scaleItemLabel)} maxRows={2} />
        </div>
      ))}
    </div>
  );
}

export default StackedHorizontalBarsLabels;
